import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      model: ''
    };
  },
  mounted() {
    this.model = this.Getter_Current_Currency.abbreviation;
  },
  computed: {
    ...mapGetters(['Getter_Current_Currency', 'Getter_Currencies_List', 'Getter_Lang']),
    currencyLabel() {
      let currency = this.Getter_Current_Currency || {};
      return currency.abbreviation + ' - ' + currency.symbol;
    },
    // 法币列表
    currencies() {
      let currencies = this.Getter_Currencies_List.map(item => {
        let objStr = JSON.stringify(item);
        let obj = JSON.parse(objStr);
        obj.label = obj.abbreviation + ' - ' + item.symbol;
        obj.value = item.abbreviation;
        return obj;
      });
      return currencies;
    }
  },
  methods: {
    ...mapMutations(['SET_CURRENCY']),
    // 切换法币
    changeCurrency(value) {
      let currency;
      let currencies = this.Getter_Currencies_List;
      if (this.Getter_Current_Currency.abbreviation === value) {
        return;
      }
      for (let i = 0, len = currencies.length; i < len; i++) {
        if (currencies[i].abbreviation === value) {
          currency = currencies[i];
          break;
        }
      }
      if (currency) {
        this.SET_CURRENCY(currency);
      }
    }
  }
};
